import { call, select, takeEvery } from 'redux-saga/effects';
import { GlobalActions, GlobalPut } from '@ps20-frontend/shop-integration-redux';
import { App, convertVermittlernummerToString } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { IAppState } from '../localStore';

export function* watchVermittlerNummerRequests() {
  yield takeEvery(
    GlobalActions.REQUEST_VERMITTLERNUMMER,
    safeSaga(provideVermittlernummer, App.SHOP),
  );
}

function* provideVermittlernummer() {
  const appState: IAppState = yield select();
  const vermittlernummer = appState.transientState.loadVorvertraege.vermittlernummer;
  const vermittlerNummerString = convertVermittlernummerToString(vermittlernummer);
  yield call(
    GlobalPut.getInstance().put,
    new GlobalActions().provideVermittlernummer(vermittlerNummerString || null),
  );
}
